// extracted by mini-css-extract-plugin
module.exports = {"channels":"Channels_channels__Aa87g"};